module.exports = __webpack_public_path__ + "media/images/game/kolo_3-3fe873a509b57278959a8aef2c9b34f6.png";